export enum Brand {
  Churchill = 'churchill',
  DirectLine = 'directline',
  Privilege = 'privilege',
}

export enum BrandName {
  Churchill = 'Churchill',
  DirectLine = 'Direct Line',
  Privilege = 'Privilege',
}

export enum BrandLowCode {
  Churchill = 'ch',
  DirectLine = 'dl',
  Privilege = 'pr',
}

export enum BrandCAPCode {
  churchill = 'CHU',
  directline = 'DLI',
  privilege = 'PRV',
}

export type BrandType = `${Brand}`;
export const BrandArray = Object.values(Brand);
